/**
 * Formats a list of strings based on Intl.ListFormat.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat
 *
 * @param {string[] | null | undefined} list - Array of strings to format.
 * @param {Intl.ListFormatOptions} options - Formatting options (style, type).
 * @param {string} locale - Locale string (e.g., 'en-US', 'uk-UA').
 *
 * @returns {string | null} Formatted list string or null if a list is missing.
 */
export default function formatList(
    list: Iterable<string> | null | undefined,
    options: Intl.ListFormatOptions = {
        style: 'long',
        type:  'conjunction',
    },
    locale: string = 'en-US',
): string | null {
    if (!list) return null;

    try {
        return new Intl.ListFormat(locale, options).format(list);
    } catch {
        return null;
    }
}
